/**
 * Dashboard GET /v2/dashboard: optional warehouseScans on the warehouse customer row only.
 */

export function normalizeDashboardRows(source) {
  if (Array.isArray(source)) return source;
  if (Array.isArray(source?.rows)) return source.rows;
  if (Array.isArray(source?.data)) return source.data;
  return [];
}

function parseWarehouseScansOnRow(row) {
  if (!row || typeof row !== "object") return null;
  const raw = row.warehouseScans ?? row.warehouse_scans;
  if (raw == null || raw === "") return null;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  if (typeof raw === "string") {
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

/**
 * @param {unknown} sourceRows – API body or array of dashboard rows
 * @returns {{ companyId: number, companyName: string, warehouseScans: number } | null}
 */
export function resolveWarehouseScansRow(sourceRows) {
  const rows = normalizeDashboardRows(sourceRows);
  const warehouseApiRow = rows.find(row => parseWarehouseScansOnRow(row) != null);
  const value = warehouseApiRow ? parseWarehouseScansOnRow(warehouseApiRow) : null;
  if (warehouseApiRow == null || value == null) return null;
  return {
    companyId: warehouseApiRow.logisticcompany_id,
    companyName: warehouseApiRow.name,
    warehouseScans: value
  };
}
